import React, { useState } from 'react';

const faqs = [
  {
    question: 'Чи підійде мені спільнота, якщо я ще не маю власної справи?',
    answer: 'Звичайно! У спільноті ти знайдеш натхнення, зможеш протестувати свої ідеї, отримати чесний фідбек від учасниць. Почнеш рухатися у напрямку створення власної справи. У оточенні сміливих і цілеспрямованих дівчат починати свій шлях легше.',
    delay: 100,
  },
  {
    question: 'Чи можу я стати учасницею, якщо я знаходжуся не в Україні?',
    answer: 'Так, звичайно. 50% наших учасниць знаходяться за кордоном або в різних містах України. Наші зустрічі з підприємцями та експертками відбуваються online щосереди.',
    delay: 200,
  },
  {
    question: 'Чи потрібно мені бути весь час активною і відвідувати усі зустрічі?',
    answer: 'З нами ти просто можеш бути собою, розвиватися у своєму темпі, відвідувати ті зустрічі, які тобі цікаві, коли тобі зручно. Тобі не обов\'язково бути весь час активною в чаті. Проте будь готовою стати підтримкою і опорою для когось у потрібний момент, бо ми точно готові зробити це для тебе.',
    delay: 300,
  },
  {
    question: 'З якої ніші вже є учасниці у спільноті?',
    answer: 'Наші дівчата розвивають свої проєкти у різних сферах та сегментах: освіта, дитячі простори, нерухомість, соціальні проєкти, психологія, нумерологія, коучинг, роздрібна торгівля, косметологія, бренди одягу, вивчення англійської мови, IT, івенти, SMM тощо. Кожна з учасниць має свою експертність та досвід у різних сферах, що створює мікросвіт у межах спільноти, в якому ти можеш знайти відповіді на будь-які питання.',
    delay: 400,
  },
  {
    question: 'Чи є якісь особливі умови для вступу у спільноту?',
    answer: 'Наша головна умова - твоє бажання до саморозвитку, самовдосконалення, розвитку твого проєкту. Не зважаючи на те, чи ти вже маєш свій бізнес, чи ти лише мрієш про нього, наші двері відкриті для амбітних і цілеспрямованих дівчат. А для того, щоб зрозуміти чи підходимо ми одна одній, у нас є пробний місяць, протягом якого ми знайомимося, звіряємося чи співпадають наші цінності, вирішуємо чи розвиваємося далі разом. Приєднуйся, щоб відчути нашу атмосферу на собі.',
    delay: 500,
  },
];

export default function FAQ() {
  const [open, setOpen] = useState(null);
  const toggle = idx => setOpen(open === idx ? null : idx);

  return (
    <section className="faq" id="questions">
      <h2>Питання, які можуть виникнути у тебе</h2>
      <div className="faq-grid">
        {faqs.map((faq, i) => (
          <div className="faq-item" data-aos="fade-up" data-aos-delay={faq.delay} key={i}>
            <button className={`faq-question ${open === i ? 'active' : ''}`} onClick={() => toggle(i)}>
              <h3>{faq.question}</h3>
              <span className="faq-icon">+</span>
            </button>
            <div className={`faq-answer ${open === i ? 'active' : ''}`}>
              <p>{faq.answer}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}